import * as types from '../constants/actionTypes';

const initialState = {
  // Roles
  roles: [],
  currentRole: null,
  roleUsers: [],
  rolesLoading: false,
  rolesError: null,
  
  // Actions
  actions: [],
  actionsGrouped: [],
  currentAction: null,
  actionsLoading: false,
  actionsError: null,
  
  // Permissions
  permissions: [],
  permissionsLoading: false,
  permissionsError: null,
  
  // Users
  users: [],
  currentUser: null,
  usersLoading: false,
  usersError: null,
  
  // UI State
  editing: null,
};

const rbacReducer = (state = initialState, action) => {
  switch (action.type) {
    // Roles
    case types.FETCH_RBAC_ROLES_REQUEST:
      return { ...state, rolesLoading: true, rolesError: null };
    case types.FETCH_RBAC_ROLES_SUCCESS:
      return { ...state, roles: action.payload, rolesLoading: false };
    case types.FETCH_RBAC_ROLES_FAILURE:
      return { ...state, rolesLoading: false, rolesError: action.payload };
    
    case types.GET_RBAC_ROLE_REQUEST:
      return { ...state, rolesLoading: true, rolesError: null };
    case types.GET_RBAC_ROLE_SUCCESS:
      return { ...state, currentRole: action.payload, rolesLoading: false };
    case types.GET_RBAC_ROLE_FAILURE:
      return { ...state, rolesLoading: false, rolesError: action.payload };
    
    case types.CREATE_RBAC_ROLE_REQUEST:
      return { ...state, rolesLoading: true, rolesError: null };
    case types.CREATE_RBAC_ROLE_SUCCESS:
      return { 
        ...state, 
        roles: [...state.roles, action.payload],
        rolesLoading: false,
        editing: null
      };
    case types.CREATE_RBAC_ROLE_FAILURE:
      return { ...state, rolesLoading: false, rolesError: action.payload };
    
    case types.UPDATE_RBAC_ROLE_REQUEST:
      return { ...state, rolesLoading: true, rolesError: null };
    case types.UPDATE_RBAC_ROLE_SUCCESS:
      return {
        ...state,
        roles: state.roles.map(role =>
          role.id === action.payload.id ? action.payload : role
        ),
        currentRole: action.payload,
        rolesLoading: false,
        editing: null
      };
    case types.UPDATE_RBAC_ROLE_FAILURE:
      return { ...state, rolesLoading: false, rolesError: action.payload };
    
    case types.DELETE_RBAC_ROLE_REQUEST:
      return { ...state, rolesLoading: true, rolesError: null };
    case types.DELETE_RBAC_ROLE_SUCCESS:
      return {
        ...state,
        roles: state.roles.filter(role => role.id !== action.payload),
        rolesLoading: false
      };
    case types.DELETE_RBAC_ROLE_FAILURE:
      return { ...state, rolesLoading: false, rolesError: action.payload };
    
    case types.FETCH_ROLE_USERS_REQUEST:
      return { ...state, usersLoading: true, usersError: null };
    case types.FETCH_ROLE_USERS_SUCCESS:
      return { ...state, roleUsers: action.payload, usersLoading: false };
    case types.FETCH_ROLE_USERS_FAILURE:
      return { ...state, usersLoading: false, usersError: action.payload };
    
    // Actions
    case types.FETCH_RBAC_ACTIONS_REQUEST:
      return { ...state, actionsLoading: true, actionsError: null };
    case types.FETCH_RBAC_ACTIONS_SUCCESS:
      return { ...state, actions: action.payload, actionsLoading: false };
    case types.FETCH_RBAC_ACTIONS_FAILURE:
      return { ...state, actionsLoading: false, actionsError: action.payload };
    
    case types.FETCH_ACTIONS_GROUPED_REQUEST:
      return { ...state, actionsLoading: true, actionsError: null };
    case types.FETCH_ACTIONS_GROUPED_SUCCESS:
      return { ...state, actionsGrouped: action.payload, actionsLoading: false };
    case types.FETCH_ACTIONS_GROUPED_FAILURE:
      return { ...state, actionsLoading: false, actionsError: action.payload };
    
    case types.CREATE_RBAC_ACTION_REQUEST:
      return { ...state, actionsLoading: true, actionsError: null };
    case types.CREATE_RBAC_ACTION_SUCCESS:
      return {
        ...state,
        actions: [...state.actions, action.payload],
        actionsLoading: false,
        editing: null
      };
    case types.CREATE_RBAC_ACTION_FAILURE:
      return { ...state, actionsLoading: false, actionsError: action.payload };
    
    case types.UPDATE_RBAC_ACTION_REQUEST:
      return { ...state, actionsLoading: true, actionsError: null };
    case types.UPDATE_RBAC_ACTION_SUCCESS:
      return {
        ...state,
        actions: state.actions.map(act =>
          act.id === action.payload.id ? action.payload : act
        ),
        actionsLoading: false,
        editing: null
      };
    case types.UPDATE_RBAC_ACTION_FAILURE:
      return { ...state, actionsLoading: false, actionsError: action.payload };
    
    case types.DELETE_RBAC_ACTION_REQUEST:
      return { ...state, actionsLoading: true, actionsError: null };
    case types.DELETE_RBAC_ACTION_SUCCESS:
      return {
        ...state,
        actions: state.actions.filter(act => act.id !== action.payload),
        actionsLoading: false
      };
    case types.DELETE_RBAC_ACTION_FAILURE:
      return { ...state, actionsLoading: false, actionsError: action.payload };
    
    // Permissions
    case types.FETCH_ROLE_PERMISSIONS_REQUEST:
      return { ...state, permissionsLoading: true, permissionsError: null };
    case types.FETCH_ROLE_PERMISSIONS_SUCCESS:
      return { ...state, permissions: action.payload, permissionsLoading: false };
    case types.FETCH_ROLE_PERMISSIONS_FAILURE:
      return { ...state, permissionsLoading: false, permissionsError: action.payload };
    
    case types.BULK_ASSIGN_PERMISSIONS_REQUEST:
      return { ...state, permissionsLoading: true, permissionsError: null };
    case types.BULK_ASSIGN_PERMISSIONS_SUCCESS:
      return { ...state, permissionsLoading: false };
    case types.BULK_ASSIGN_PERMISSIONS_FAILURE:
      return { ...state, permissionsLoading: false, permissionsError: action.payload };
    
    case types.TOGGLE_PERMISSION_REQUEST:
      return { ...state, permissionsLoading: true, permissionsError: null };
    case types.TOGGLE_PERMISSION_SUCCESS:
      return { ...state, permissionsLoading: false };
    case types.TOGGLE_PERMISSION_FAILURE:
      return { ...state, permissionsLoading: false, permissionsError: action.payload };
    
    // Users
    case types.FETCH_RBAC_USERS_REQUEST:
      return { ...state, usersLoading: true, usersError: null };
    case types.FETCH_RBAC_USERS_SUCCESS:
      return { ...state, users: action.payload, usersLoading: false };
    case types.FETCH_RBAC_USERS_FAILURE:
      return { ...state, usersLoading: false, usersError: action.payload };
    
    case types.GET_RBAC_USER_REQUEST:
      return { ...state, usersLoading: true, usersError: null };
    case types.GET_RBAC_USER_SUCCESS:
      return { ...state, currentUser: action.payload, usersLoading: false };
    case types.GET_RBAC_USER_FAILURE:
      return { ...state, usersLoading: false, usersError: action.payload };
    
    case types.UPDATE_USER_ROLE_REQUEST:
      return { ...state, usersLoading: true, usersError: null };
    case types.UPDATE_USER_ROLE_SUCCESS:
      return {
        ...state,
        users: state.users.map(user =>
          user.id === action.payload.id ? action.payload : user
        ),
        usersLoading: false
      };
    case types.UPDATE_USER_ROLE_FAILURE:
      return { ...state, usersLoading: false, usersError: action.payload };
    
    case types.REMOVE_USER_ROLE_REQUEST:
      return { ...state, usersLoading: true, usersError: null };
    case types.REMOVE_USER_ROLE_SUCCESS:
      return {
        ...state,
        users: state.users.map(user =>
          user.id === action.payload ? { ...user, role_id: null, role_name: null } : user
        ),
        usersLoading: false
      };
    case types.REMOVE_USER_ROLE_FAILURE:
      return { ...state, usersLoading: false, usersError: action.payload };
    
    // UI State
    case types.SET_RBAC_EDITING:
      return { ...state, editing: action.payload };
    case types.CLEAR_RBAC_EDITING:
      return { ...state, editing: null };
    
    default:
      return state;
  }
};

export default rbacReducer;
